var _a;
import { __decorate, __metadata } from "tslib";
import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import BaseVue from '~/nasa_ui/base/BaseVue';
let AppFileUpload = class AppFileUpload extends BaseVue {
    showMaxFileSizeExceededMessage = false;
    isImage = false;
    isPdf = false;
    isVideo = false;
    disabled;
    multiple;
    value;
    truncateLength;
    mbMax;
    get buttonText() {
        if (!this.value) {
            return 'No file chosen';
        }
        if (Array.isArray(this.value)) {
            if (this.value.length === 0) {
                return 'No file chosen';
            }
            if (this.value.length === 1) {
                return this.formatFileName(this.value[0].name);
            }
            return `${this.value.length} files selected`;
        }
        return this.formatFileName(this.value.name);
    }
    formatFileName(name) {
        if (name.length > this.truncateLength + 3) {
            return name.slice(0, this.truncateLength) + '...';
        }
        return name;
    }
    get maxFileSizeExceededMessage() {
        return `Max file size is ${this.mbMax}MB`;
    }
    get uniqueKey() {
        return Math.random().toString(36).substring(2);
    }
    // ferry the button click event down to the file input element
    onClickOfFileSelect() {
        this.$refs['fileInput']?.click();
    }
    onChangeOfValue(value) {
        if (!value) {
            this.$refs['fileInput'].value = '';
        }
    }
    async onFileChange(event) {
        this.showMaxFileSizeExceededMessage = false;
        const el = event.target;
        if (this.multiple) {
            const files = el.files ? Array.from(el.files) : [];
            for (const file of files) {
                const sizeInMegaBytes = (file?.size ?? 0) / 1024 / 1024;
                if (sizeInMegaBytes > this.mbMax) {
                    this.showMaxFileSizeExceededMessage = true;
                    this.fileTooLarge();
                    return null;
                }
            }
            return files;
        }
        else {
            const file = el.files ? el.files[0] : null;
            const sizeInMegaBytes = (file?.size ?? 0) / 1024 / 1024;
            if (sizeInMegaBytes > this.mbMax) {
                this.showMaxFileSizeExceededMessage = true;
                this.fileTooLarge();
                return null;
            }
            return file;
        }
    }
    fileTooLarge() { }
};
__decorate([
    Prop({
        type: Boolean,
        default: false
    }),
    __metadata("design:type", Boolean)
], AppFileUpload.prototype, "disabled", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false
    }),
    __metadata("design:type", Boolean)
], AppFileUpload.prototype, "multiple", void 0);
__decorate([
    Prop({
        default: null
    }),
    __metadata("design:type", Object)
], AppFileUpload.prototype, "value", void 0);
__decorate([
    Prop({
        type: Number,
        default: 75
    }),
    __metadata("design:type", Number)
], AppFileUpload.prototype, "truncateLength", void 0);
__decorate([
    Prop({
        type: Number,
        default: 500
    }),
    __metadata("design:type", Number)
], AppFileUpload.prototype, "mbMax", void 0);
__decorate([
    Watch('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AppFileUpload.prototype, "onChangeOfValue", null);
__decorate([
    Emit('input'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a = typeof Event !== "undefined" && Event) === "function" ? _a : Object]),
    __metadata("design:returntype", Promise)
], AppFileUpload.prototype, "onFileChange", null);
__decorate([
    Emit('file-too-large'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AppFileUpload.prototype, "fileTooLarge", null);
AppFileUpload = __decorate([
    Component
], AppFileUpload);
export default AppFileUpload;
